import { PayloadAction } from '@reduxjs/toolkit';
import { actions as groupUiStates, UploadCounters, WriteableGroupUiState } from '@ff-scene-plugins/photo-prints-redux/slices/groupsUiSlice';
import { PhotoPrintsPdpThunk } from '@ff-scene-plugins/photo-prints-redux/store';

const timeoutsByIdByProperty = {} as Record<keyof WriteableGroupUiState, Record<string, number>>;

const withScheduledReset = <TKey extends keyof WriteableGroupUiState, TPayload>(
    groupId: string, key: TKey, action: PayloadAction<TPayload>
): PhotoPrintsPdpThunk => {

    return dispatch => {

        if (timeoutsByIdByProperty[key]?.[groupId]) {
            clearTimeout(timeoutsByIdByProperty[key][groupId]);
        }

        const timeoutId = window.setTimeout(() => {
            dispatch(groupUiStates.reset({ id: groupId, key }));
        }, 3000);

        timeoutsByIdByProperty[key] = {
            ...timeoutsByIdByProperty[key],
            [groupId]: timeoutId
        };

        dispatch(action);
    };
};

export const incrementWithScheduledReset = (
    id: string,
    key: UploadCounters,
    incrementBy = 1
): PhotoPrintsPdpThunk => {
    return withScheduledReset(id, key, groupUiStates.increment({ id, key, incrementBy }));
};

export const updateWithScheduledReset = <
    TState extends Omit<WriteableGroupUiState, UploadCounters>,
    TKey extends keyof Omit<WriteableGroupUiState, UploadCounters>
>(
    payload: { id: string; key: TKey; value: TState[TKey] }
): PhotoPrintsPdpThunk => {
    return withScheduledReset(payload.id, payload.key, groupUiStates.update(payload));
};